/**
 * Helpers for the S3 custom file name field.
 *
 * Only fields already selected for export can be offered or accepted: anything else is
 * never extracted, so the file name would silently fall back to the default at run time.
 * Date and boolean values do not make useful, stable file name segments.
 */

export const EXCLUDED_FIELD_TYPES = ['Date', 'Boolean']

const normalise = value => String(value ?? '').trim().toLowerCase()

/**
 * objectSelectList holds plain field names once loaded from the API, but the step 1 picker
 * emits field objects while the user is editing, so both shapes have to be understood.
 */
export const fieldNameOf = field => {
	if (field == null) return ''
	if (typeof field === 'object') return String(field.fieldName ?? field.cassieObjectFieldName ?? '')
	return String(field)
}

export function isFieldSelected (selectedFields, fieldName) {
	const wanted = normalise(fieldName)
	if (!wanted) return false
	return (selectedFields || []).some(field => normalise(fieldNameOf(field)) === wanted)
}

export function buildFilenameFieldOptions (availableFields, selectedFields) {
	return (availableFields || [])
		.filter(field => isFieldSelected(selectedFields, field?.fieldName))
		.filter(field => !EXCLUDED_FIELD_TYPES.includes(field?.typeFriendlyName))
		.map(field => ({
			text: field.displayName || field.fieldName,
			value: field.fieldName
		}))
}
